<button class="btn btn-sm btn-outline-secondary back-button" 
        (click)="goBack()" 
        title="Go back">
  <i class="bi bi-chevron-left"></i>
</button>


<!-- <button class="btn btn-sm p-0 border-0" (click)="goBack()" title="Go back"
          style="transition: all 0.2s ease; text-shadow: 0 2px 4px rgba(0,0,0,0.1);"
          onmouseover="this.style.transform='scale(1.1)'; this.querySelector('i').classList.remove('text-secondary'); this.querySelector('i').classList.add('text-primary');"
          onmouseout="this.style.transform='scale(1)'; this.querySelector('i').classList.remove('text-primary'); this.querySelector('i').classList.add('text-secondary');"
          onmousedown="this.style.transform='scale(0.95)';"
          onmouseup="this.style.transform='scale(1.1)';">
    <i class="bi bi-arrow-left-circle fs-3 text-secondary"></i>
  </button> -->
 
